import { storage } from "../firebase";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

/**
 * Uploads a file to Firebase Cloud Storage and returns the file URL.
 * @param {File} file - The file to upload.
 * @param {string} path - The path where the file should be stored.
 * @param {function} onProgress - (Optional) Callback for tracking upload progress.
 * @returns {Promise<string>} - The download URL of the uploaded file.
 */
const uploadFileToCloud = (file, path, onProgress) => {
  return new Promise((resolve, reject) => {

    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        if (onProgress) {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(progress);
        }
      },
      (error) => {
        reject(error);
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadURL);
      }
    );
  });
};

export default uploadFileToCloud;
